import OrganizationApi from 'app/api/OrganizationApi';
import useIsMounted from 'app/hooks/useIsMounted';
import cx from 'classnames';
import { useEffect, useRef, useState } from 'react';
import { Input, useToasts } from 'tombac';
import "./OrganizationNameEditor.css";
import { jsx as _jsx } from "react/jsx-runtime";
export default function OrganizationNameEditor({
  className,
  name,
  readOnly = false,
  onBlur,
  onChange,
  onNameChange,
  onFocus,
  onKeyUp,
  orgId,
  ...rest
}) {
  const mounted = useIsMounted();
  const {
    addToast
  } = useToasts();
  const cancelled = useRef(false);
  const [editing, setEditing] = useState(false);
  const [value, setValue] = useState(name);
  useEffect(() => {
    setValue(name);
  }, [name]);
  const saveName = async () => {
    setEditing(false);
    if (name === value || cancelled.current) {
      cancelled.current = false;
      return;
    }
    const org = await OrganizationApi.get(orgId);
    try {
      await OrganizationApi.update(orgId, {
        name: value.trim(),
        parentId: org.parentId
      });
    } catch (error) {
      console.error(error);
      addToast(error?.message || error, 'danger');
      if (mounted.current) {
        setValue(name);
        setEditing(true);
      }
    }
    if (mounted.current && onNameChange) onNameChange();
  };
  const cancelChange = () => {
    setValue(name);
    cancelled.current = true;
    if (document.activeElement instanceof HTMLElement) document.activeElement.blur();
  };
  return /*#__PURE__*/_jsx(Input, {
    className: cx('OrganizationNameEditor', readOnly && 'OrganizationNameEditor--read-only', className),
    disabled: readOnly,
    onBlur: event => {
      saveName();
      if (onBlur) onBlur(event);
    },
    onChange: event => {
      setValue(event.target.value);
      if (onChange) onChange(event);
    },
    onFocus: event => {
      setEditing(true);
      if (onFocus) onFocus(event);
    },
    onKeyUp: event => {
      event.key === 'Enter' ? saveName() : event.key === 'Escape' && cancelChange();
      if (onKeyUp) onKeyUp(event);
    },
    readOnly: !editing,
    type: "text",
    value: value,
    ...rest,
    "data-sentry-element": "Input",
    "data-sentry-component": "OrganizationNameEditor",
    "data-sentry-source-file": "OrganizationNameEditor.tsx"
  });
}